import { action } from 'typesafe-actions';
import { StoreState, STORES_TYPES } from './types';

export const getStoreList = () => action(STORES_TYPES.GET_STORELIST_REQUEST);

export const setStoreList = (data: StoreState[]) =>
  action(STORES_TYPES.SET_DATA_STORELIST, data);
